var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-submenu-back"},[_c('div',{staticClass:"container"},[_c('a',{staticClass:"navbar-item",on:{"click":_vm.back}},[_c('span',{staticClass:"c-navbar-back--svg-icon"},[_c('base-icon',{attrs:{"width":"25","height":"25","name":"painel/arrow-left-icon"}})],1),_c('span',[_vm._v("Voltar")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }